import { Link, Stack } from '@mui/material'
import type { FormConfig } from '@workwave-tidal/core/form'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectMobileAppInteraction } from '@/features/domain/territory'

import type { DriverAssistanceFormValues } from '../../types'
import { FormFooter } from './DriverAssistanceFormFooter'
import { FormContent } from './FormContent'
import { form, initialValues } from './formState'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useTexts } from './hooks/useTexts'
import { computeInitialValues } from './utils/computeInitialValues'

export function DriverAssistanceForm() {
  const formValues = useSelector(selectMobileAppInteraction)

  const onSubmit = useOnSubmit()
  const texts = useTexts()
  const config = useMemo<FormConfig<DriverAssistanceFormValues>>(
    () => ({
      id: 'driver-assistance-form',
      initialValues: { ...initialValues, ...computeInitialValues(formValues) },

      // Fields have been declared inside the config, since not every component is mounted at the same time of the form
      fields: {
        type: {},
        checkIn: {},
        checkOut: {},
        includePicture: {},
        includePictureChecked: {},
        includeSignature: {},
        includeSignatureChecked: {},
        includeAudio: {},
        includeAudioChecked: {},
        includeNote: {},
        includeNoteChecked: {},
        includeStatusChecked: {},
      },
    }),
    [formValues],
  )

  return (
    <form.Form
      title={texts.title}
      subtitle={
        <Stack spacing={1}>
          <span>{texts.headerDescription}</span>
          <Link
            href="https://workwave.my.site.com/routemanager/s/article/Enhanced-Required-Actions-for-Drivers"
            underline="none"
            target="_blank"
          >
            {texts.learnMore}
          </Link>
        </Stack>
      }
      footer={<FormFooter />}
      onSubmit={onSubmit}
      config={config}
      requireTransaction={false}
      stopEditingOnUnmount
      disableScroll
      applyPendingFitMapOnMount={false}
      testId="driver-assistance-form"
    >
      <FormContent />
    </form.Form>
  )
}
